import { createSlice, AnyAction } from "@reduxjs/toolkit";
import { updateViewList } from "@reducers/_utils/reducer-helpers";
import type { BannersState } from "../types";

const initialState: BannersState = {
  bannerPositions: {},
  live: [],
  expired: [],
  expired_total: 0,
  live_total: 0,
  page_number: 1,
  pre_page_number: 1,
  isLoading: false,
};

const bannersSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("LOAD_BANNERS_START", (state) => {
        state.isLoading = true;
      })
      .addCase("LOAD_BANNERS", (state, action: AnyAction) => {
        Object.assign(state, action.payload);
        state.isLoading = false;
      })
      .addCase("SET_PAGE_NUMBER", (state, action: AnyAction) => {
        Object.assign(state, action.pages);
      })
      .addCase("ADD_BANNER_ITEM", (state, action: AnyAction) => {
        const status = action.status as "live" | "expired";
        (state as any)[status] = [
          action.itemDetails,
          ...(state as any)[status],
        ];
      })
      .addCase("UPDATE_BANNER_ITEM", (state, action: AnyAction) => {
        const keyLookUp = `${action.itemType}_id`;
        const itemDetails =
          action.updateAction === "update" ? action.itemDetails : null;
        (state as any)[action.setSelected] = updateViewList(
          keyLookUp,
          action.itemDetails[keyLookUp],
          (state as any)[action.setSelected],
          itemDetails
        );
      })
      .addCase("SET_POSITIONS", (state, action: AnyAction) => {
        state.bannerPositions = (action.positions as any[]).reduce(
          (acc: Record<string, string>, cur: any) => {
            acc[cur.position as string] = cur.position_label as string;
            return acc;
          },
          {}
        );
      });
  },
});

export const selectBanners = (state: { banners: BannersState }): BannersState =>
  state.banners;

export default bannersSlice.reducer;
